<script>
import { Line } from "vue-chartjs";

export default {
	extends: Line,
	props: {
    chartdata: {
      type: Object,
      default: null
    },
   //  options: {
   //    type: Object,
   //    default: null
   //  }
  },
	data() {
		return {
			labels: [2017, 2018, 2019, 2020, 2021],
			datasets: [
				{
					data: [10, 59, 80, 81, 56],
				},
			],
			options: {
				animation: {
					duration: 1000,
					easing: "linear",
				},
				maintainAspectRatio: false,
				responsive: true,
				scales: {
					yAxes: [{ ticks: { beginAtZero: true, stepSize: 5 } }],
					xAxes: [{ barThickness: 39 }],
				},
				legend: {
					display: false,
				},
				tooltips: {
					mode: "index",
					intersect: false,
				},
			},
		};
	},
	mounted() {
		this.renderChart(this.chartdata, this.options);
	},
	methods: {
	},
};
</script>

<style>
</style>